// Injects the Tauri permission IPC calls (mic pair via `recorderFmc`,
// accessibility trio via `@/tauri/dictation/permissions`) into
// @heidi/dictate's permissions-ports seam (SCR-7069). Imported for effect
// in `_app.tsx`. The package short-circuits to "granted" off-Tauri, so the
// ports are only reached after this wiring has run.
import { recorderFmc, type MicPermissionStatus } from '@/tauri/controller/recording';
import {
  checkAccessibilityPermission,
  openAccessibilityPrivacySettings,
  requestAccessibilityPermission,
} from '@/tauri/dictation/permissions';
import { configureDictationPermissionsPorts, type PermissionState } from '@heidi/dictate';

export function toDictationMicPermission(status: MicPermissionStatus): PermissionState {
  switch (status) {
    case 'Authorized':
      return 'granted';
    case 'Denied':
    case 'Restricted':
      return 'denied';
    // A never-asked mic is not a refusal, so it maps to 'unknown': the UI still
    // offers "Allow", and the revoked-access toast stays quiet.
    case 'NotDetermined':
    case 'Error':
      return 'unknown';
    default: {
      const unhandled: never = status;
      return unhandled;
    }
  }
}

configureDictationPermissionsPorts({
  readMicrophonePermission: async () =>
    toDictationMicPermission(await recorderFmc.read_microphone_permission_status()),
  requestMicrophonePermission: () => recorderFmc.request_microphone_permission(),
  openMicrophoneSettings: () => recorderFmc.open_mic_privacy_settings(),
  checkAccessibilityPermission,
  requestAccessibilityPermission,
  openAccessibilityPrivacySettings,
});
